import { fileShareRenameFile } from '@wix/bi-logger-wixlabs-ugc/v2';

export const biFileShareWidgetRenameFile = (props: any) => {
  const {
    instance_id,
    app_id,
    logger,
    visitor_id,
    comp_id,
    owner,
    file_id,
    file_name,
    file_owner,
    file_size,
    file_type,
    favorites_count,
    is_folder,
    views_count,
  } = props;
  logger?.report(
    fileShareRenameFile({
      instance_id,
      app_id,
      visitor_id,
      comp_id,
      owner,
      file_id,
      file_name,
      file_owner,
      file_size,
      file_type,
      favorites_count,
      is_folder,
      views_count,
    }),
  );
};
